<!--选择城市-->
<template>
  <div class="container-flex">
    <div id="map-container"></div>
    <!-- <div class="select-station-tm" v-if="selectStation.staPkId" @click="resetSelectStation"></div> -->
    <div class="select-station-box" v-if="selectStation.staPkId">
      <pi-station-item
        :item="selectStation"
        @change="collected"
      ></pi-station-item>
    </div>
  </div>
</template>

<script>
import stationItem from "@/components/pi-station-item/pi-station-item.vue";
import AMap from "AMap"; // 引入高德地图
export default {
  name: "pi-home-map",
  components: {
    [stationItem.name]: stationItem,
  },
  props: {
    stationList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    markers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    latitude: {
      type: Number,
      default: 0,
    },
    longitude: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    stationList: function (val) {
      this.markData(val);
    },
  },
  data() {
    return {
      map: null,
      marks: [],
      selectStation: {},
      markerClickLoading: false,
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      this.map = new AMap.Map("map-container", {
        mapStyle: "amap://styles/af8b23e5696f50c4c60f7b8b4e57cd85",
        resizeEnable: true,
        center: [this.longitude, this.latitude], //地图中心点
        zoom: 11, //地图显示的缩放级别
      });
      this.markData(this.stationList);
      this.map.on("click", () => {
        this.resetSelectStation();
      });
    },
    setZoomAndCenter(item) {
      this.map.setCenter([item.userLng, item.userLat]);
    },

    markData(markData) {
      this.marks.forEach((item) => {
        this.map.remove(item);
      });
      this.marks = [];
      let that = this;
      let width = 0.72 * this.$config.fontSize;
      let height = 0.74 * this.$config.fontSize;
      if (markData) {
        let image = require("../../../../picture/index/mark.png");
        let icon = new AMap.Icon({
          size: new AMap.Size(width, height), // 图标尺寸
          image: image, // Icon的图像
          imageSize: new AMap.Size(width, height), // 根据所设置的大小拉伸或压缩图片
        });
        markData.forEach((item) => {
          const marker = new AMap.Marker({
            position: new AMap.LngLat(item.staLng, item.staLat),
            offset: new AMap.Pixel(-width / 2, -height),
            icon: icon, // 添加 Icon 图标 URL
            title: "",
          });

          this.marks.push(marker);
          marker.setMap(this.map);
          //添加点标记事件
          marker.on("click", function () {
            that.getSelectSta(item.staPkId);
          });
        });
      }
    },
    /**
     * 点标记点击事件
     */
    getSelectSta(id) {
      this.selectStation =
        this.stationList.filter((item) => {
          return item.staPkId == id;
        })[0] || {};
      this.$emit("markerclick", this.selectStation);
    },
    /**
     * 关掉站点框
     */
    resetSelectStation() {
      this.selectStation = {};
      this.$emit("markerclick", this.selectStation);
    },
    /**
     * 收藏
     */
    collected(item) {
      this.selectStation = item;
    },
  },
};
</script>

<style lang="less" scoped>
#map-container {
  height: 100%;
}
.container-flex {
  position: relative;
}
.select-station-box {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 1.4rem;
  padding: 0 0.2rem;
  box-sizing: border-box;
  z-index: 10;
}
.select-station-tm {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  // background: rgba(0, 0, 0, 0.3);
}
</style>
